// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k2nF","col":"styles_col__3lWJP"};